module.exports = __webpack_public_path__ + "img/file----------------------------1x-png-1@1x.c0b27f83.png";